 export enum PrimoboxTypeEnvoiTraitement {
Inconnu = 0,
CoffreFort = 1,
Courrier = 2,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/PrimoboxTypeEnvoiTraitement.ts